export default {
  items: [
    {
      name: '맵 타입',
      url: '/mapType',
      icon: 'fa fa-map fa-lg mt-1'
    },
    {
      name: '사이트',
      url: '/site',
      icon: 'fa fa-sitemap fa-lg mt-1'
    },
    {
      name: '사이트 버전',
      url: '/siteVersion',
      icon: 'fa fa-tags fa-lg mt-1'
    },
    {
      name: '데이터 파일',
      url: '/dataFile',
      icon: 'fa fa-database fa-lg mt-1'
    },
    {
      name: '데이터 파일 Reload',
      url: '/reload',
      icon: 'fa fa-refresh fa-lg',
      class: 'mt-auto',
      variant: 'success'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/_nav.js